import { render } from "./TournamentStartList.vue?vue&type=template&id=3cd65eee&scoped=true"
import script from "./TournamentStartList.vue?vue&type=script&lang=js"
export * from "./TournamentStartList.vue?vue&type=script&lang=js"

import "./TournamentStartList.vue?vue&type=style&index=0&id=3cd65eee&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd65eee"]])

export default __exports__